export const isUserAuthenticated = (): boolean =>
  document
    .querySelector('meta[name="user-authenticated"]')
    ?.getAttribute('content') === 'true';
